<app-card
  cardTitle
  cardClass="card-datatable"
  [options]="false">
  <form
    (ngSubmit)="search()"
    class="filterform">
    <div class="row">
      <div class="col-md-6">
        <div class="form-group d-flex flex-row">
          <input
            type="text"
            class="form-control d-inline"
            name="keyword"
            placeholder="Cerca..."
            [(ngModel)]="searchparams.genericSearchTerm">
          <button
            type="button"
            class="btn btn-link ml-2"
            (click)="toggleAdvanced()">
            <i class="feather icon-filter"></i>

          </button>
        </div>
      </div>
      <div class="col-md-4 mt-1">
        <div class="form-group">
          <div class="form-check form-check-inline">
            <input
              type="checkbox"
              class="form-check-input"
              name="active"
              [(ngModel)]="active">
            <label class="form-check-label">
              {{'labels.show-only-active' | translate}}
            </label>
          </div>
        </div>
      </div>

    </div>
    <div [ngbCollapse]="!showAdvancedSearch">
      <div class="row">
        <!-- company -->
        <div
          class="col-md-4"
          *ngIf="!companyid">
          <label>{{'labels.company' | translate}}</label>
          <select
            class="form-control custom-select"
            [(ngModel)]="searchparams.simpleTmp['companyid']"
            name="contract">
            <option
              *ngFor="let company of companies"
              [value]="company.id">
              {{company.name}}
            </option>
          </select>

        </div>
        <!-- value -->
        <div class="col-md-4 mb-1 value-col">
          <label>{{'labels.value' | translate}}</label>
          <div class="row">
            <div class="col-md-2">{{'labels.from' | translate}}:</div>
            <div class="col-md-4">
              <input
                type="number"
                class="form-control"
                name="from"
                [(ngModel)]="value.from">
            </div>
            <div class="col-md-2">{{'labels.to' | translate}}:</div>
            <div class="col-md-4">
              <input
                type="number"
                class="form-control"
                name="to"
                [(ngModel)]="value.to">
            </div>
          </div>
        </div>
      </div>

    </div>
    <div class="row mt-1">
      <div class="col">
        <button
          type="submit"
          class="btn btn-primary">
          {{'labels.search' | translate}}
        </button>
        <a
          (click)="resetSearch()"
          class="btn btn-default">
          {{'labels.reset' | translate}}
        </a>
      </div>

    </div>
  </form>
</app-card>
